import * as vp from 'vopay';
import { createContext } from 'react';

export type UsersCtx = {
  userDeleteError: string;
  showUserDeleteErrorAlert: boolean;
  showUserDeleteSuccessAlert: boolean;
  userCreateError: string;
  showUserCreateErrorAlert: boolean;
  showUserCreateSuccessAlert: boolean;
  userChangePasswordError: string;
  showUserChangePasswordErrorAlert: boolean;
  showUserChangePasswordSuccessAlert: boolean;
  showUserDeleteConfirmationAlert: boolean;
  showUserChangePasswordConfirmationAlert: boolean;
  accountUser: string;
  accountUserEmailAddress: string;
  accountUserPermissions: {
    Username: string;
    Permissions: vp.AccountUserPermissions
  }
};

const UsersContext = createContext<UsersCtx>({
  userDeleteError: '',
  showUserDeleteErrorAlert: false,
  showUserDeleteSuccessAlert: false,
  userCreateError: '',
  showUserCreateErrorAlert: false,
  showUserCreateSuccessAlert: false,
  userChangePasswordError: '',
  showUserChangePasswordErrorAlert: false,
  showUserChangePasswordSuccessAlert: false,
  showUserChangePasswordConfirmationAlert: false,
  showUserDeleteConfirmationAlert: false,
  accountUser: '',
  accountUserEmailAddress: '',
  accountUserPermissions: {
    Username: '',
    Permissions: {
      ViewSubaccounts: false,
      AddSubaccounts: false,
      CreatePayments: false,
      CreateCollections: false,
      ViewBeneficiaries: false,
      AddBeneficiaries: false,
      ViewBulkFileUpload: false,
      CreateBulkFileUpload: false,
      ViewScheduledTransactions: false,
      ViewTransactionHistory: false,
      ViewSettings: false,
      AddSettings: false,
      ViewUsers: false,
      AddUsers: false,
      ApproveTransactions: false,
      ManageUserPermissions: false,
      CreateAccountTransfer: false,
      ViewClientAccounts: false,
      AddClientAccounts: false,
      CreateClientAccountTransfers: false,
      CreateConversions: false,
      ManageDefaultPayments: false,
      CreateSupportTickets: false,
      ViewSupportTickets: false,
      ViewReconciliation: false,
    }
  }
});

export default UsersContext;
